export default __webpack_public_path__ + "static/media/sxp.78951004.png";